<template>
  <div class="techerDivDisplay" v-if="data">
    <title-widge :title="title" :subTitle="subTitle" style="padding-bottom:61px"></title-widge>
    <div>
      <common-techer-display-widge :imgs="teacherData" v-if="teacherData.length>0">
      </common-techer-display-widge>
    </div>
  </div>
</template>

<script>
import titleWidge from "./titleWidge";
import commonTecherDisplayWidge from "../../common/components/techerDisplayWidge";
export default {
  components: {
    titleWidge,
    commonTecherDisplayWidge,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: "",
      subTitle: "",
      teacherData: [],
    };
  },
  watch: {
    data(obj) {
      if (obj) {
        this.title = obj.title;
        this.subTitle = obj.subTitle;
        let lieBiao = obj.lieBiao;
        let teacherData = [];
        for (let item of lieBiao) {
          teacherData.push({
            name: item.title,
            quarters: item.subTitle,
            headerImage: item.image,
            details: item.description,
          });
        }
        this.teacherData = teacherData;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/techerDisplayWidge"
</style>
